export const ENQUIRY_STAGES = [
  'new',
  'contacted',
  'site_visit',
  'quoted',
  'negotiation',
  'won',
  'lost',
] as const

export type EnquiryStage = (typeof ENQUIRY_STAGES)[number]

export const ENQUIRY_STAGE_LABELS: Record<EnquiryStage, string> = {
  new: 'New',
  contacted: 'Contacted',
  site_visit: 'Site Visit',
  quoted: 'Quoted',
  negotiation: 'Negotiation',
  won: 'Won',
  lost: 'Lost',
}

export const ENQUIRY_STAGE_BADGE_CLASS: Record<EnquiryStage, string> = {
  new: 'border-slate-300 bg-slate-50 text-slate-700',
  contacted: 'border-sky-300 bg-sky-50 text-sky-800',
  site_visit: 'border-violet-300 bg-violet-50 text-violet-800',
  quoted: 'border-amber-300 bg-amber-50 text-amber-800',
  negotiation: 'border-orange-300 bg-orange-50 text-orange-800',
  won: 'border-emerald-300 bg-emerald-50 text-emerald-800',
  lost: 'border-rose-300 bg-rose-50 text-rose-800',
}

export function getEnquiryStageLabel(stage: string | null | undefined) {
  const value = String(stage || 'new') as EnquiryStage
  return ENQUIRY_STAGE_LABELS[value] ?? value
}

export function getEnquiryStageBadgeClass(stage: string | null | undefined) {
  const value = String(stage || 'new') as EnquiryStage
  return ENQUIRY_STAGE_BADGE_CLASS[value] ?? ENQUIRY_STAGE_BADGE_CLASS.new
}

export function isEnquiryStage(value: string | null | undefined): value is EnquiryStage {
  return ENQUIRY_STAGES.includes(String(value || '') as EnquiryStage)
}
